import { FC } from 'react'
import { Link, LinkButton } from 'components/extend/Link'
import ModalItem from 'components/ModalItem'
import { MODAL_IDS, useModal } from 'components/ModalProvider'
import { deliveryDocsUrl, deliveryRulesUrl } from 'modules/order/helpers'
import IconInformation from 'remixicon/icons/System/information-line.svg?react'
import { CourierDeliveryInfo, OrderItemClient } from 'schema'

import { ModalIdentificationDocuments } from '../ModalIdentificationDocuments/ModalIdentificationDocuments'

type OrderCreateInfoBlockProps = {
  clientType: OrderItemClient.type | undefined
  pointType: CourierDeliveryInfo.pointType
}

export const OrderCreateInfoBlock: FC<OrderCreateInfoBlockProps> = (props) => {
  const { pointType, clientType } = props
  const { openModal, closeModal } = useModal()

  const modalId =
    pointType === CourierDeliveryInfo.pointType.DESTINATION
      ? MODAL_IDS.IdentificationDocumentsDestination
      : MODAL_IDS.IdentificationDocumentsDeparture

  const handleOpenModalIdentificationDocuments = () => {
    openModal(modalId)
  }

  return (
    <>
      <ModalItem id={modalId}>
        <ModalIdentificationDocuments
          handleCloseModalIdentificationDocuments={() => closeModal(modalId)}
          id={modalId}
        />
      </ModalItem>

      <div className="flex gap-4 rounded bg-surface-variant p-3">
        <IconInformation className="text-on-surface-variant" containerSize="nm" size="xs" />
        <div>
          {clientType === OrderItemClient.type.LEGAL ? (
            <div>
              Потребуется{' '}
              <Link className="!text-on-surface-link" target="_parent" to={deliveryDocsUrl(pointType)}>
                доверенность
              </Link>{' '}
              от юр. лица и документ, удостоверяющий личность, указанный в доверенности.{' '}
            </div>
          ) : (
            <div>
              Потребуется паспорт или документ из{' '}
              <LinkButton className="!text-on-surface-link" onClick={handleOpenModalIdentificationDocuments}>
                перечня
              </LinkButton>
              .{' '}
            </div>
          )}
          <a
            className="!bg-none !text-on-surface-link"
            href={deliveryRulesUrl(pointType)}
            rel="noreferrer"
            target="_blank"
          >
            Все правила {pointType === CourierDeliveryInfo.pointType.DEPARTURE ? 'отправки' : 'получения'} груза.
          </a>
        </div>
      </div>
    </>
  )
}
